/**
 * Returns a string with its first character capitalized. The rest of
 * the string is returned as-is — uppercase letters elsewhere are
 * preserved. Pass `value.toLowerCase()` if you also need the rest
 * lowercased.
 */

export const capitalizeFirstLetter = (stringValue: string) =>
  stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
